// extracted by mini-css-extract-plugin
export default {"text":"RichTextModule_text__J3yq+"};